export enum WorkspaceDocumentsEmbeddedTab {
  EDITABLE = 'editable',
  READ_ONLY = 'readOnly',
}
